enum HttpHeader {
    AccessToken = "Access-Token",
    UserId = "Uid",
    Version = "Version",
    TimeZone = "Time-Zone",
}

export default HttpHeader;
